export const isTobacco = (intakeSurvey: Partial<IntakeSurvey>) => {
  return (
    intakeSurvey.clientSmokerEver === 'Yes' ||
    intakeSurvey.clientSmokedRecently === 'Yes' ||
    checkForSpecificConditions(intakeSurvey.clientSubstancesUsed ?? [], [
      'cigarettes',
      'cigars',
      'pipes',
      'hookahs',
      'vapes',
      'chewing tobacco',
      'tobacco',
      'e-cigarettes',
      'ecigarettes',
    ])
  );
};

const checkForSpecificConditions = (
  sourceList: string[] | string,
  conditionKeywords: string[],
): boolean => {
  if (
    !sourceList ||
    (Array.isArray(sourceList) && sourceList.length === 0) ||
    !conditionKeywords ||
    conditionKeywords.length === 0
  )
    return false;

  const sourceArray =
    typeof sourceList === 'string'
      ? sourceList.split('|').map(s => s.trim().toLowerCase())
      : sourceList.map(s => s.trim().toLowerCase());

  return sourceArray.some(diagnosis =>
    conditionKeywords.some(keyword => diagnosis.includes(keyword.toLowerCase())),
  );
};
